let alarmAudio = null;
let alarmUnlocked = false;

const TRADE_ALARM_ENABLED_KEY = 'spxGammaTradeAlarmEnabled';
const MARKET_INTELLIGENCE_ALARM_ENABLED_KEY =
  'spxGammaMarketIntelligenceAlarmEnabled';

function getBooleanLocalStorageValue(key) {
  return localStorage.getItem(key) === 'true';
}

function setBooleanLocalStorageValue(key, enabled) {
  localStorage.setItem(key, enabled ? 'true' : 'false');
}

function shouldKeepAudioUnlocked() {
  return (
    getTradeAlarmToggleState() ||
    getMarketIntelligenceAlarmToggleState()
  );
}

// -----------------------------------------------------------------------------
// Shared alarm audio
// -----------------------------------------------------------------------------

export function initializeTradeAlarm() {
  if (!alarmAudio) {
    alarmAudio = new Audio('/sounds/trade-alert.mp3');
    alarmAudio.preload = 'auto';
    alarmAudio.volume = 0.85;
  }

  return alarmAudio;
}

export function initializeMarketIntelligenceAlarm() {
  return initializeTradeAlarm();
}

async function unlockAlarmAudio() {
  const audio = initializeTradeAlarm();

  try {
    audio.muted = true;
    await audio.play();
    audio.pause();
    audio.currentTime = 0;
    audio.muted = false;

    alarmUnlocked = true;
    return true;
  } catch (error) {
    alarmUnlocked = false;
    console.warn('[ALARM] Browser blocked audio unlock:', error);
    return false;
  }
}

async function playAlarmAudio(label = 'ALARM') {
  if (!alarmUnlocked) return;

  const audio = initializeTradeAlarm();

  try {
    audio.currentTime = 0;
    await audio.play();
  } catch (error) {
    console.warn(`[${label}] Failed to play alarm:`, error);
  }
}

// -----------------------------------------------------------------------------
// Trade alarm
// -----------------------------------------------------------------------------

export function isTradeAlarmEnabled() {
  return getTradeAlarmToggleState() && alarmUnlocked;
}

export function getTradeAlarmToggleState() {
  return getBooleanLocalStorageValue(TRADE_ALARM_ENABLED_KEY);
}

export function setTradeAlarmEnabled(enabled) {
  setBooleanLocalStorageValue(TRADE_ALARM_ENABLED_KEY, enabled);
}

export async function unlockTradeAlarm() {
  const unlocked = await unlockAlarmAudio();

  if (!unlocked) {
    console.warn('[TRADE ALARM] Browser blocked audio unlock.');
  }

  return unlocked;
}

export async function enableTradeAlarm() {
  const unlocked = await unlockTradeAlarm();

  if (!unlocked) {
    setTradeAlarmEnabled(false);
    return false;
  }

  setTradeAlarmEnabled(true);
  return true;
}

export function disableTradeAlarm() {
  setTradeAlarmEnabled(false);

  if (!shouldKeepAudioUnlocked()) {
    alarmUnlocked = false;
  }
}

export async function playTradeAlarm() {
  if (!isTradeAlarmEnabled()) return;

  await playAlarmAudio('TRADE ALARM');
}

// -----------------------------------------------------------------------------
// Market Intelligence alarm
// -----------------------------------------------------------------------------

export function isMarketIntelligenceAlarmEnabled() {
  return getMarketIntelligenceAlarmToggleState() && alarmUnlocked;
}

export function getMarketIntelligenceAlarmToggleState() {
  return getBooleanLocalStorageValue(MARKET_INTELLIGENCE_ALARM_ENABLED_KEY);
}

export function setMarketIntelligenceAlarmEnabled(enabled) {
  setBooleanLocalStorageValue(
    MARKET_INTELLIGENCE_ALARM_ENABLED_KEY,
    enabled
  );
}

export async function unlockMarketIntelligenceAlarm() {
  const unlocked = await unlockAlarmAudio();

  if (!unlocked) {
    console.warn('[MIS ALARM] Browser blocked audio unlock.');
  }

  return unlocked;
}

export async function enableMarketIntelligenceAlarm() {
  const unlocked = await unlockMarketIntelligenceAlarm();

  if (!unlocked) {
    setMarketIntelligenceAlarmEnabled(false);
    return false;
  }

  setMarketIntelligenceAlarmEnabled(true);
  return true;
}

export function disableMarketIntelligenceAlarm() {
  setMarketIntelligenceAlarmEnabled(false);

  if (!shouldKeepAudioUnlocked()) {
    alarmUnlocked = false;
  }
}

export async function playMarketIntelligenceAlarm() {
  if (!isMarketIntelligenceAlarmEnabled()) return;

  await playAlarmAudio('MIS ALARM');
}





//Tradr alarm before MI data feed alarm.
// let alarmAudio = null;
// let alarmUnlocked = false;
//
// const ALARM_ENABLED_KEY = 'spxGammaTradeAlarmEnabled';
//
// export function isTradeAlarmEnabled() {
//   return localStorage.getItem(ALARM_ENABLED_KEY) === 'true' && alarmUnlocked;
// }
//
// export function getTradeAlarmToggleState() {
//   return localStorage.getItem(ALARM_ENABLED_KEY) === 'true';
// }
//
// export function setTradeAlarmEnabled(enabled) {
//   localStorage.setItem(ALARM_ENABLED_KEY, enabled ? 'true' : 'false');
// }
//
// export function initializeTradeAlarm() {
//   if (!alarmAudio) {
//     alarmAudio = new Audio('/sounds/trade-alert.mp3');
//     alarmAudio.preload = 'auto';
//     alarmAudio.volume = 0.85;
//   }
//
//   return alarmAudio;
// }
//
// export async function unlockTradeAlarm() {
//   const audio = initializeTradeAlarm();
//
//   try {
//     audio.muted = true;
//     await audio.play();
//     audio.pause();
//     audio.currentTime = 0;
//     audio.muted = false;
//
//     alarmUnlocked = true;
//     return true;
//   } catch (error) {
//     alarmUnlocked = false;
//     console.warn('[TRADE ALARM] Browser blocked audio unlock:', error);
//     return false;
//   }
// }
//
// export async function enableTradeAlarm() {
//   const unlocked = await unlockTradeAlarm();
//
//   if (!unlocked) {
//     setTradeAlarmEnabled(false);
//     return false;
//   }
//
//   setTradeAlarmEnabled(true);
//   return true;
// }
//
// export function disableTradeAlarm() {
//   alarmUnlocked = false;
//   setTradeAlarmEnabled(false);
// }
//
// export async function playTradeAlarm() {
//   if (!isTradeAlarmEnabled()) return;
//
//   const audio = initializeTradeAlarm();
//
//   try {
//     audio.currentTime = 0;
//     await audio.play();
//   } catch (error) {
//     console.warn('[TRADE ALARM] Failed to play alarm:', error);
//   }
// }